// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.font_size_createPipeline {
  font-size: 12px !important;
}
.font_size_createPipeline ::ng-deep .autocomplete-container .input-container input {
  padding-right: 14% !important;
}

.multiprocessor_div_control {
  font-size: 12px !important;
}
.multiprocessor_div_control ::ng-deep .autocomplete-container .input-container input {
  padding-right: 23% !important;
}

.fieldsize {
  width: 75%;
}

.ng-autocompleteaccount {
  width: 100%;
}

.ng-autocompleteprocess {
  width: 355px;
}

.ng-autocompleteroutr {
  width: 370px;
}

.tryitout {
  color: white;
  float: right;
  margin-right: 15px;
}

.tableWrapper {
  width: 100%;
}

.table tr.active td {
  background-color: #87ceeb !important;
  color: white;
}

.docs-example-viewer-title {
  align-items: center;
  display: flex;
  padding: 1px 1px 1px 16px;
}

.mat-list-item.active {
  color: #fff !important;
}

.processor_label {
  float: left;
  padding-right: 2%;
  position: relative;
  top: 8px;
}

.processor_feild {
  float: left;
  width: 100%;
}

.processor_feild_mapping {
  float: left;
  width: 89%;
}

.mapping_btn {
  padding-left: 1%;
  position: relative;
  top: 16%;
  left: 1%;
}

.pipeline_label {
  float: left;
  padding-right: 3%;
  position: relative;
  top: 8px;
}

.pipeline_feild {
  float: left;
  width: 100%;
}

.source_label {
  float: left;
  padding-right: 4%;
  position: relative;
  top: 8px;
}

.source_feild {
  float: left;
  width: 100%;
}

.target_label {
  float: left;
  padding-right: 7%;
  position: relative;
  top: 8px;
}

.target_feild {
  float: left;
  width: 100%;
}

.target-button {
  float: left;
}

.sourcebutton {
  float: left;
}

.test_label {
  float: left;
  padding-left: 16%;
  font-size: 13px;
  position: relative;
  top: -12%;
}

.switch_label {
  float: left;
  padding-left: 41%;
  font-size: 13px;
}

@media screen and (min-width: 700px) and (max-width: 1024px) {
  .processor_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 8px;
  }
  .processor_feild {
    float: left;
    width: 76%;
  }
  .pipeline_label {
    float: left;
    padding-right: 3%;
    position: relative;
    top: 8px;
  }
  .pipeline_feild {
    float: left;
    width: 76%;
  }
  .source_label {
    float: left;
    padding-right: 4%;
    position: relative;
    top: 8px;
  }
  .source_feild {
    float: left;
    width: 100%;
  }
  .target_label {
    float: left;
    padding-right: 7%;
    position: relative;
    top: 8px;
  }
  .target_feild {
    float: left;
    width: 100%;
  }
  .test_label {
    float: unset;
    padding-left: 16%;
    font-size: 13px;
  }
  .switch_label {
    float: unset;
    padding-left: 17%;
    font-size: 13px;
  }
}
@media screen and (min-width: 500px) and (max-width: 786px) {
  .processor_label {
    float: left;
    padding-right: 2%;
    position: unset;
    top: 8px;
  }
  .processor_feild {
    float: left;
    width: 97%;
  }
  .pipeline_label {
    float: left;
    padding-right: 3%;
    position: unset;
    top: 8px;
  }
  .pipeline_feild {
    float: left;
    width: 97%;
  }
  .source_label {
    float: left;
    padding-right: 4%;
    position: unset;
    top: 8px;
  }
  .source_feild {
    float: left;
    width: 100%;
  }
  .target_label {
    float: left;
    padding-right: 11%;
    position: unset;
    top: 8px;
  }
  .target_feild {
    float: left;
    width: 100%;
  }
  .test_label {
    float: unset;
    padding-left: 16%;
    font-size: 13px;
  }
  .switch_label {
    float: unset;
    padding-left: 17%;
    font-size: 13px;
  }
}
::ng-deep.mappingCheck label {
  margin-bottom: 0;
}

.mode_select {
  width: 69%;
  top: -2px;
  background-color: white;
  border: 1px solid rgba(128, 128, 128, 0.2901960784);
  border-radius: 5px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  padding-left: 4%;
}

::ng-deep .mat-form-field-appearance-legacy .mat-form-field-wrapper {
  padding-bottom: 0 !important;
  margin-top: -8px !important;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline {
  height: 0px !important;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {
  top: 0;
  height: 0px !important;
  overflow: hidden;
}

.port-margin {
  margin-left: 3%;
}

::ng-deep.mode_select .mat-select-trigger {
  min-width: 0 !important;
}

.fonts_size {
  font-size: 12px !important;
}

.tfp_copy_icon {
  float: right;
  font-size: 18px !important;
  position: absolute;
  right: 1%;
  cursor: pointer;
  top: 20%;
}

.tfp_mail_icon {
  font-size: 19px !important;
  position: absolute;
  right: 7%;
  cursor: pointer;
  top: 20%;
}

.vitalrbidge_card {
  border: 1px solid rgba(0, 0, 0, 0.13);
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
}

.headerdark {
  background-color: #defee4;
  color: black;
  padding-block: 4px;
  position: relative;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
}

.multiprocessor_div {
  background-color: whitesmoke;
}

::ng-deep.multiselect .multiselect-dropdown .dropdown-list {
  max-height: 190px;
  overflow-x: hidden;
  overflow-y: auto;
  position: absolute;
  padding-top: -12px;
  width: 100%;
  z-index: 9999;
  border: 1px solid #ccc;
  border-radius: 3px;
  background: #fff;
  /* margin-top: 10px; */
  box-shadow: 0 1px 5px #959595;
}

.active_table {
  background-color: rgba(23, 162, 184, 0.231372549);
}

.configtable td {
  padding: 1% !important;
}

.configtable tr:hover {
  background-color: #f3eded;
  cursor: pointer;
}

.configicon {
  position: relative;
  left: 65%;
}

.copy_icon {
  background-repeat: no-repeat;
  display: inline-block;
  fill: currentColor;
  height: 24px;
  width: 24px;
  font-size: 18px;
  position: relative;
  left: 3px;
  cursor: pointer;
  text-align: center;
  z-index: 999;
}

.message_type {
  width: 100%;
  margin-left: 1%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  top: -1px;
  height: 31px;
  line-height: 19px;
  padding-left: 4%;
}

::ng-deep .message_type .mat-form-field-appearance-legacy .mat-form-field-wrapper {
  padding-bottom: 0 !important;
  margin-top: -4px !important;
}

::ng-deep .mat-form-field-appearance-legacy .mat-form-field-wrapper {
  padding-bottom: 0 !important;
  margin-top: -8px !important;
}

.text-ellipsis {
  max-width: 83%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::ng-deep .pipeline_feild .autocomplete-container.input-container input:disabled {
  background-color: #eee !important;
}

::ng-deep .pipeline_feild.pipleline_input .autocomplete-container .input-container input {
  box-shadow: 0 1px 1px #959595 !important;
  height: 30px !important;
  border: transparent !important;
}

.configbtn_style {
  border: none;
  border-top: 34px solid #fafafa !important;
  border-right: 34px solid #17a0b4 !important;
  border-bottom: 34px solid #fafafa !important;
  border-left-color: #17a0b4 !important;
}

.filecompare_input {
  height: 30px !important;
  font-size: 11px;
  padding-left: 1%;
}

.filecompare_input,
input::-webkit-input-placeholder {
  font-size: 11px !important;
}

.vpninputstyle {
  height: 30px !important;
  font-size: 11px;
  padding-left: 1%;
  border-radius: 5px;
  width: 100%;
}

.vpninputstyle,
input::-webkit-input-placeholder {
  font-size: 11px !important;
}

.addconfigbtn {
  background-color: #17a0b4 !important;
  font-size: 12px !important;
  color: white;
  height: 28px !important;
  line-height: 20px;
  right: 1%;
  top: 0%;
  cursor: pointer;
}

.dot {
  height: 22px;
  width: 25px;
  background-color: #17a0b4 !important;
  border-radius: 50%;
  display: inline-block;
}

.agentsearch_field {
  height: 28px !important;
  padding: 0%;
  padding-left: 2%;
  font-size: 12px !important;
}

.agentsearch_field::placeholder {
  font-size: 12px !important;
}

.agentfilter_feild {
  width: 94% !important;
}

.additioninfo_active {
  color: green !important;
}

.additioninfo_inactive {
  color: red !important;
}

.description {
  font-size: 12px !important;
}

::ng-deep.interfacedescriptioncreate .modal-dialog {
  max-width: 40% !important;
  max-height: 40% !important;
  height: 30% !important;
  margin: auto !important;
  padding: 0 !important;
  top: 10% !important;
}

::ng-deep.interfacedescriptioncreate {
  top: 10% !important;
}

::ng-deep.additionalsettingmodal .modal-dialog {
  max-width: 40% !important;
  max-height: 40% !important;
  height: 30% !important;
  margin: auto !important;
  padding: 0 !important;
  top: 16% !important;
}

::ng-deep.additionalsettingmodal {
  top: 16% !important;
}

::ng-deep.saveVendormodalcreate .modal-dialog {
  max-width: 58% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.saveVendormodalcreate {
  top: 16% !important;
}

::ng-deep.modalConfigcreate .modal-dialog {
  max-width: 36% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
  top: 24% !important;
}

::ng-deep.modalConfigJSONcreate .modal-dialog {
  max-width: 79% !important;
  margin: auto !important;
  padding: 0 !important;
  top: 0% !important;
}

.recreate_btn {
  border: none;
  border-radius: 17px;
  box-shadow: 1px 1px 4px 1px grey;
  cursor: pointer;
}

.copyicon {
  position: absolute;
  right: 13%;
  top: 22%;
  font-size: 18px;
  cursor: pointer;
}

.folderpathvaftp {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 16px;
  right: 3%;
}

.folderpathftp {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  right: 3%;
}

.copyicon_pn {
  right: 14%;
}

.copyicon_proc {
  right: 17%;
}

.copyicon_procsub {
  right: 15%;
  top: 26%;
  position: absolute;
  font-size: 18px;
}

.copyicon_procsubedit {
  right: 8%;
  top: 13%;
  position: absolute;
  font-size: 18px;
}

.mappingbtnprocsubedit {
  padding-left: 1%;
  position: relative;
  top: 3%;
  left: 6%;
}

.rightbottom {
  position: absolute;
  bottom: 0;
  width: 100%;
}

.modal.drawer {
  display: flex !important;
  pointer-events: none;
}
.modal.drawer * {
  pointer-events: none;
}
.modal.drawer .modal-dialog {
  margin: 0px;
  flex: auto;
  transform: translate(25%, 0);
}
.modal.drawer .modal-dialog .modal-content {
  border: none;
  border-radius: 0px;
}
.modal.drawer .modal-dialog .modal-content .modal-body {
  overflow: auto;
}
.modal.drawer.show {
  pointer-events: auto;
}
.modal.drawer.show * {
  pointer-events: auto;
}
.modal.drawer.show .modal-dialog {
  transform: translate(0, 0);
}
.modal.drawer.right-align {
  flex-direction: row-reverse;
}
.modal.drawer.left-align:not(.show) .modal-dialog {
  transform: translate(-25%, 0);
}
.modal .modal-title {
  font-size: 14px;
}

::ng-deep.duplicate-modal-rightcreate.drawer.right-align .modal-dialog {
  position: fixed;
  right: 0;
  top: 16%;
  bottom: 0;
  width: 50%;
  max-width: 50%;
  height: 100%;
  margin: 0;
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
}
::ng-deep.duplicate-modal-rightcreate.drawer.right-align.show .modal-dialog {
  transform: translateX(0);
}

.folder_path_input {
  font-size: 11px !important;
  box-sizing: border-box !important;
  border: none !important;
  box-shadow: none !important;
  outline: 0 !important;
  background-color: #fff !important;
  color: rgba(0, 0, 0, 0.87) !important;
  width: 100% !important;
  padding: 0 15px !important;
  line-height: 30px !important;
  height: 30px !important;
  border-radius: 5px !important;
  padding-left: 5px !important;
  position: relative;
  padding-right: 10% !important;
  box-shadow: 0px 1px 5px 0px grey !important;
}

.projectimportradio {
  height: auto !important;
}

.otherradio {
  max-height: 62vh;
  overflow-x: hidden;
  overflow-y: auto;
}

/* API contract mode: allow autocomplete suggestions outside the card */
.api-connectivity-card {
  max-height: none !important;
  overflow-x: hidden;
  overflow-y: visible !important;
}

/* Ensure no intermediate wrapper clips the API agent suggestion panel */
.api-connectivity-card .card-body,
.api-connectivity-card .fonts_size,
.api-contract-controls-row,
.api-connectivity-card .ng-autocompleteaccount,
.api-connectivity-card .ng-autocompleteaccount form,
.api-connectivity-card .api-contract-agent-field,
.api-connectivity-card .api-contract-agent-field .autocomplete-container,
.api-connectivity-card .api-contract-agent-field .autocomplete-container .suggestions-container {
  overflow: visible !important;
}

.form-control {
  border-radius: 5px !important;
  font-size: 1rem !important;
  height: 110px !important;
}

::ng-deep.devicesearch .autocomplete-container .suggestions-container.is-visible {
  position: fixed !important;
  width: 28% !important;
  visibility: visible;
}

.fieldstyle {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  height: 30px !important;
  border-radius: 5px !important;
  border: transparent;
  width: 98% !important;
}

.visibility_off {
  color: #17a2b8;
  height: 19px !important;
  width: 33px !important;
  font-size: 19px;
  padding-left: 13px;
  position: relative;
  top: 1px;
  cursor: pointer;
}

.visibilityftp {
  color: #17a2b8;
  height: 19px !important;
  width: 33px !important;
  font-size: 19px;
  cursor: pointer;
}

.additional_seting {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 12px;
}

.status-live {
  height: 7px;
  width: 7px;
  background-color: #06d306;
  border-radius: 50%;
  position: relative;
  bottom: 3px;
  left: -2px;
  animation: blink 1s infinite;
}

.externalftfp_copy_icon {
  float: right;
  font-size: 18px !important;
  position: absolute;
  right: 1%;
  cursor: pointer;
  top: 3%;
  color: black;
}

@keyframes blink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}
::ng-deep.vendorauto .input-container input:disabled {
  cursor: not-allowed !important;
}

/* Additional Info card loader */
::ng-deep .additional-info-spinner circle {
  stroke: #17a2b8 !important;
}

::ng-deep .additional-info-spinner .mdc-circular-progress__indeterminate-circle-graphic {
  stroke: #17a2b8 !important;
}

/* Saved pipeline: read-only connectivity — neutral panel + accent; left-aligned (not centered) */
.connectivity-readonly-summary {
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  margin: 6px 0 12px;
  padding: 0;
  line-height: 1.4;
}

.connectivity-readonly-chip {
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  min-height: 44px;
  padding: 11px 16px 12px;
  text-align: left;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 0 8px 8px 0;
  border-left: 3px solid #0f766e;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
}

.connectivity-readonly-value {
  display: block;
  width: 100%;
  min-width: 0;
  color: #0f172a;
  font-size: 14px !important;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: -0.01em;
  word-break: break-word;
}

/* Compact auth type select shown above API contract builder */
::ng-deep .auth-type-field .mat-mdc-text-field-wrapper {
  padding-bottom: 0 !important;
  margin: 0 !important;
}

::ng-deep .auth-type-field .mat-mdc-form-field-flex {
  min-height: 34px !important;
  height: 34px !important;
  align-items: center;
}

::ng-deep .auth-type-field .mat-mdc-form-field-infix {
  border-top: 0 !important;
  padding: 0.35em 0 0.35em 0 !important;
}

::ng-deep .api-contract-agent-field .autocomplete-container .input-container input {
  min-height: 34px !important;
  height: 34px !important;
  line-height: 34px !important;
  box-sizing: border-box;
}

/* Fixed width for VA-API agent picker only */
.api-contract-agent-field {
  width: 310px;
  max-width: 310px;
  flex: 0 0 310px;
}

.api-contract-agent-field .apiagentsearch,
::ng-deep .api-contract-agent-field .autocomplete-container {
  width: 100%;
  max-width: 310px;
}

/* Keep API agent suggestions above neighboring controls */
::ng-deep .api-contract-agent-field .autocomplete-container .suggestions-container.is-visible {
  z-index: 10050 !important;
}

/* Escape clipped parent cards (otherradio / card-body scroll areas) */
::ng-deep .apiagentsearch .autocomplete-container .suggestions-container.is-visible {
  position: fixed !important;
  width: 300px !important;
  max-height: 240px;
  overflow-y: auto;
  z-index: 10050 !important;
  visibility: visible;
}

.api-connectivity-card-body {
  max-height: none !important;
  overflow-y: visible !important;
}

.agent-info-namediv {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.agent-info-namediv:hover {
  background-color: #3fa4fb;
  border-radius: 12px;
  color: white !important;
  padding: 3px !important;
  cursor: pointer;
  font-weight: 600;
}

.copy_iconss {
  font-size: 16px;
  cursor: pointer;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/create/create.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,0BCFS;ADEX;AAEE;EACE,6BAAA;AAAJ;;AAGA;EACE,0BCTS;ADSX;AAEE;EACE,6BAAA;AAAJ;;AAGA;EAEE,UAAA;AADF;;AAIA;EAEE,WAAA;AAFF;;AAIA;EACE,YAAA;AADF;;AAGA;EACE,YAAA;AAAF;;AAEA;EAEE,YAAA;EACA,YAAA;EACA,kBAAA;AAAF;;AAKA;EACE,WAAA;AAFF;;AAKA;EACE,oCAAA;EACA,YAAA;AAFF;;AAKA;EACE,mBAAA;EACA,aAAA;EACA,yBAAA;AAFF;;AAUA;EACE,sBAAA;AAPF;;AAsCA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAnCF;;AAqCA;EACE,WAAA;EACA,WAAA;AAlCF;;AAoCA;EACE,WAAA;EACA,UAAA;AAjCF;;AAmCA;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;AAhCF;;AAkCA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AA/BF;;AAiCA;EACE,WAAA;EACA,WAAA;AA9BF;;AAgCA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AA7BF;;AA+BA;EACE,WAAA;EACA,WAAA;AA5BF;;AA8BA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AA3BF;;AA6BA;EACE,WAAA;EACA,WAAA;AA1BF;;AA4BA;EACE,WAAA;AAzBF;;AA2BA;EACE,WAAA;AAxBF;;AA2BA;EACE,WAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;AAxBF;;AA0BA;EACE,WAAA;EACA,iBAAA;EACA,eAAA;AAvBF;;AA0BA;EACE;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAvBF;EAyBA;IACE,WAAA;IACA,UAAA;EAvBF;EAyBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAvBF;EAyBA;IACE,WAAA;IACA,UAAA;EAvBF;EAyBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAvBF;EAyBA;IACE,WAAA;IACA,WAAA;EAvBF;EAyBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAvBF;EAyBA;IACE,WAAA;IACA,WAAA;EAvBF;EA0BA;IACE,YAAA;IACA,iBAAA;IACA,eAAA;EAxBF;EA0BA;IACE,YAAA;IACA,iBAAA;IACA,eAAA;EAxBF;AACF;AA2BA;EACE;IACE,WAAA;IACA,iBAAA;IACA,eAAA;IACA,QAAA;EAzBF;EA2BA;IACE,WAAA;IACA,UAAA;EAzBF;EA2BA;IACE,WAAA;IACA,iBAAA;IACA,eAAA;IACA,QAAA;EAzBF;EA2BA;IACE,WAAA;IACA,UAAA;EAzBF;EA2BA;IACE,WAAA;IACA,iBAAA;IACA,eAAA;IACA,QAAA;EAzBF;EA2BA;IACE,WAAA;IACA,WAAA;EAzBF;EA2BA;IACE,WAAA;IACA,kBAAA;IACA,eAAA;IACA,QAAA;EAzBF;EA2BA;IACE,WAAA;IACA,WAAA;EAzBF;EA4BA;IACE,YAAA;IACA,iBAAA;IACA,eAAA;EA1BF;EA4BA;IACE,YAAA;IACA,iBAAA;IACA,eAAA;EA1BF;AACF;AA4BA;EACE,gBAAA;AA1BF;;AA6BA;EACE,UAAA;EACA,SAAA;EACA,uBAAA;EACA,mDAAA;EACA,kBAAA;EACA,+GAAA;EACA,gBAAA;AA1BF;;AA6BA;EACE,4BAAA;EACA,2BAAA;AA1BF;;AA6BA;EACE,sBAAA;AA1BF;;AA4BA;EACE,MAAA;EACA,sBAAA;EACA,gBAAA;AAzBF;;AA4BA;EACE,eAAA;AAzBF;;AA2BA;EACE,uBAAA;AAxBF;;AA2BA;EACE,0BChTS;ADwRX;;AA2BA;EACE,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,QAAA;AAxBF;;AA0BA;EACE,0BAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,QAAA;AAvBF;;AAyBA;EACE,qCAAA;EACA,kBAAA;EACA,oDAAA;AAtBF;;AAyBA;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,4BAAA;EACA,oDAAA;AAtBF;;AAyBA;EAEE,4BAAA;AAvBF;;AA+BI;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,6BAAA;AA7BN;;AAiCA;EACE,iDAAA;AA9BF;;AAgCA;EACE,sBAAA;AA7BF;;AA+BA;EACE,yBAAA;EACA,eAAA;AA5BF;;AA8BA;EACE,kBAAA;EACA,SAAA;AA3BF;;AA6BA;EACE,4BAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AA1BF;;AA4BA;EACE,WAAA;EACA,eAAA;EACA,+GAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAzBF;;AA2BA;EACE,4BAAA;EACA,2BAAA;AAxBF;;AA0BA;EACE,4BAAA;EACA,2BAAA;AAvBF;;AAyBA;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAtBF;;AAwBA;EACE,iCAAA;AArBF;;AAuBA;EACE,wCAAA;EACA,uBAAA;EACA,8BAAA;AApBF;;AAsBA;EACE,YAAA;EACA,yCAAA;EACA,2CAAA;EACA,4CAAA;EACA,qCAAA;AAnBF;;AAqBA;EACE,uBC7aW;ED8aX,eAAA;EACA,gBAAA;AAlBF;;AAqBA;;EAEE,0BAAA;AAlBF;;AAoBA;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACF,WAAA;AAjBA;;AAmBA;;EAEE,0BAAA;AAhBF;;AAkBA;EACE,oCCtcU;EDucV,0BCtcS;EDucT,YAAA;EACA,uBCtcU;EDucV,iBAAA;EACA,SAAA;EACA,OAAA;EACA,eAAA;AAfF;;AAiBA;EACE,YAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,qBAAA;AAdF;;AAgBA;EACE,uBCpdU;EDqdV,WAAA;EACA,gBAAA;EACA,0BCzdS;AD4cX;;AAeA;EACE,0BC5dS;ADgdX;;AAcA;EACE,qBAAA;AAXF;;AAaA;EACE,uBAAA;AAVF;;AAYA;EACE,qBAAA;AATF;;AAWA;EACE,0BCxeS;ADgeX;;AAWA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;AARF;;AAUA;EACE,mBAAA;AAPF;;AAUA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;AAPF;;AASA;EACE,mBAAA;AANF;;AASA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AANF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;AALF;;AAQA;EACE,yBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;AALF;;AAQA;EACE,YAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;AALF;;AAQA;EAEE,kBAAA;EACE,UAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;AANJ;;AAQA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,SAAA;AALF;;AAOA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;AAJF;;AAMA;EAEA,UAAA;AAJA;;AAMA;EAEE,UAAA;AAJF;;AAMA;EACE,UAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;AAHF;;AAKA;EAEE,SAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;AAHF;;AAKA;EACE,gBAAA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;AAFJ;;AAIA;EAEE,kBAAA;EACE,SAAA;EACA,WAAA;AAFJ;;AAKE;EACE,wBAAA;EACA,oBAAA;AAFJ;AAII;EACE,oBAAA;AAFN;AAKI;EACE,WAAA;EACA,UAAA;EACA,4BAAA;AAHN;AAKM;EACE,YAAA;EACA,kBAAA;AAHR;AAKQ;EACE,cAAA;AAHV;AASI;EACE,oBAAA;AAPN;AASM;EACE,oBAAA;AAPR;AAUM;EACE,0BAAA;AARR;AAYI;EACE,2BAAA;AAVN;AAeQ;EACE,6BAAA;AAbV;AAmBE;EACE,eAAA;AAjBJ;;AAuBI;EACE,eAAA;EACA,QAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,sCAAA;AApBN;AAuBI;EACE,wBAAA;AArBN;;AA2BA;EACE,0BAAA;EACE,iCAAA;EACA,uBAAA;EACA,2BAAA;EACA,qBAAA;EACA,iCAAA;EACA,qCAAA;EACA,sBAAA;EACA,0BAAA;EACA,4BAAA;EACA,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,kBAAA;EACA,6BAAA;EACA,2CAAA;AAxBJ;;AA2BA;EACE,uBAAA;AAxBF;;AA2BA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;AAxBF;;AA2BA,uEAAA;AACA;EACE,2BAAA;EACA,kBAAA;EACA,8BAAA;AAxBF;;AA2BA,wEAAA;AACA;;;;;;;;EAQE,4BAAA;AAxBF;;AA0BA;EACE,6BAAA;EACA,0BAAA;EACA,wBAAA;AAvBF;;AAyBA;EACA,0BAAA;EACA,qBAAA;EACA,mBAAA;AAtBA;;AAwBA;EACE,yCAAA;EAAuC,uBAAA;EAAyB,6BAAA;EAAkC,mBAAA;EAClG,qBAAA;AAlBF;;AAoBA;EACE,cAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;AAjBF;;AAmBA;EACE,cAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;AAhBF;;AAkBA;EACG,aAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;AAfH;;AAiBA;EACE,WAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,4BAAA;AAdF;;AAgBA;EACE,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,OAAA;EACA,YAAA;AAbF;;AAeA;EACE;IAAW,UAAA;EAXX;EAYA;IAAM,YAAA;EATN;AACF;AAUA;EACE,8BAAA;AARF;;AAWA,gCAAA;AACA;EACE,0BAAA;AARF;;AAWA;EACE,0BAAA;AARF;;AAWA,iGAAA;AACA;EACE,aAAA;EACA,2BAAA;EACA,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,0BAAA;EACA,8BAAA;EACA,4CAAA;AARF;;AAWA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;AARF;;AAUA,8DAAA;AACA;EACE,4BAAA;EACA,oBAAA;AAPF;;AAUA;EACE,2BAAA;EACA,uBAAA;EACA,mBAAA;AAPF;;AAUA;EACE,wBAAA;EACA,qCAAA;AAPF;;AASA;EACE,2BAAA;EACA,uBAAA;EACA,4BAAA;EACA,sBAAA;AANF;;AASA,6CAAA;AACA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;AANF;;AASA;;EAEE,WAAA;EACA,gBAAA;AANF;;AASA,0DAAA;AACA;EACE,yBAAA;AANF;;AASA,sEAAA;AACA;EACE,0BAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AANF;;AASA;EACE,2BAAA;EACA,8BAAA;AANF;;AASA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AANF;;AASA;EACE,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AANF;;AASA;EACE,eAAA;EACA,eAAA;EACA,cAAA;AANF","sourcesContent":["@import \"../../variables.scss\";\r\n\r\n.font_size_createPipeline {\r\n  font-size: $fontsize;\r\n\r\n  ::ng-deep .autocomplete-container .input-container input{\r\n    padding-right: 14% !important;\r\n  }\r\n}\r\n.multiprocessor_div_control{\r\n  font-size: $fontsize;\r\n\r\n  ::ng-deep .autocomplete-container .input-container input{\r\n    padding-right: 23% !important;\r\n  }\r\n}\r\n.fieldsize\r\n{\r\n  width: 75%;\r\n}\r\n\r\n.ng-autocompleteaccount {\r\n  //width: 355px;\r\n  width: 100%;\r\n}\r\n.ng-autocompleteprocess {\r\n  width: 355px;\r\n}\r\n.ng-autocompleteroutr {\r\n  width: 370px;\r\n}\r\n.tryitout {\r\n  // background-color: #ff6105;\r\n  color: white;\r\n  float: right;\r\n  margin-right: 15px;\r\n}\r\n\r\n//interface mapping css\r\n\r\n.tableWrapper {\r\n  width: 100%;\r\n}\r\n\r\n.table tr.active td {\r\n  background-color: #87ceeb !important;\r\n  color: white;\r\n}\r\n\r\n.docs-example-viewer-title {\r\n  align-items: center;\r\n  display: flex;\r\n  padding: 1px 1px 1px 16px;\r\n}\r\n\r\n// .ng-autocompleteselect {\r\n//   background-color: #203cdb;\r\n//   border: 1px solid transparent;\r\n//   padding: 1px;\r\n// }\r\n.mat-list-item.active {\r\n  color: #fff !important;\r\n  //background-color: #17a2b8;\r\n}\r\n\r\n// ::ng-deep.autocomplete-container {\r\n// box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n// position: relative;\r\n// overflow: visible;\r\n// height: 40px;\r\n// border-radius: 5px;\r\n// }\r\n\r\n// ::ng-deep.autocomplete-container .input-container input{\r\n// border-radius: 5px !important;\r\n// padding-right: 12% !important;\r\n// }\r\n\r\n// .autocomplete-container {\r\n// border-radius: 5px !important;\r\n// }\r\n// ::ng-deep.autocomplete-container .input-container .x i{\r\n// font-weight: 600 !important;\r\n// }\r\n\r\n// ::ng-deep.pipeSearch .autocomplete-container {\r\n// height: 35px !important;\r\n// .input-container input{\r\n// height: 35px !important;\r\n// }\r\n// }\r\n\r\n.processor_label {\r\n  float: left;\r\n  padding-right: 2%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.processor_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n.processor_feild_mapping {\r\n  float: left;\r\n  width: 89%;\r\n}\r\n.mapping_btn {\r\n  padding-left: 1%;\r\n  position: relative;\r\n  top: 16%;\r\n  left: 1%;\r\n}\r\n.pipeline_label {\r\n  float: left;\r\n  padding-right: 3%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.pipeline_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n.source_label {\r\n  float: left;\r\n  padding-right: 4%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.source_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n.target_label {\r\n  float: left;\r\n  padding-right: 7%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.target_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n.target-button {\r\n  float: left;\r\n}\r\n.sourcebutton {\r\n  float: left;\r\n}\r\n\r\n.test_label {\r\n  float: left;\r\n  padding-left: 16%;\r\n  font-size: 13px;\r\n  position: relative;\r\n  top: -12%;\r\n}\r\n.switch_label {\r\n  float: left;\r\n  padding-left: 41%;\r\n  font-size: 13px;\r\n}\r\n\r\n@media screen and (min-width: 700px) and (max-width: 1024px) {\r\n  .processor_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n  .processor_feild {\r\n    float: left;\r\n    width: 76%;\r\n  }\r\n  .pipeline_label {\r\n    float: left;\r\n    padding-right: 3%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n  .pipeline_feild {\r\n    float: left;\r\n    width: 76%;\r\n  }\r\n  .source_label {\r\n    float: left;\r\n    padding-right: 4%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n  .source_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n  .target_label {\r\n    float: left;\r\n    padding-right: 7%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n  .target_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n\r\n  .test_label {\r\n    float: unset;\r\n    padding-left: 16%;\r\n    font-size: 13px;\r\n  }\r\n  .switch_label {\r\n    float: unset;\r\n    padding-left: 17%;\r\n    font-size: 13px;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 500px) and (max-width: 786px) {\r\n  .processor_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: unset;\r\n    top: 8px;\r\n  }\r\n  .processor_feild {\r\n    float: left;\r\n    width: 97%;\r\n  }\r\n  .pipeline_label {\r\n    float: left;\r\n    padding-right: 3%;\r\n    position: unset;\r\n    top: 8px;\r\n  }\r\n  .pipeline_feild {\r\n    float: left;\r\n    width: 97%;\r\n  }\r\n  .source_label {\r\n    float: left;\r\n    padding-right: 4%;\r\n    position: unset;\r\n    top: 8px;\r\n  }\r\n  .source_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n  .target_label {\r\n    float: left;\r\n    padding-right: 11%;\r\n    position: unset;\r\n    top: 8px;\r\n  }\r\n  .target_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n\r\n  .test_label {\r\n    float: unset;\r\n    padding-left: 16%;\r\n    font-size: 13px;\r\n  }\r\n  .switch_label {\r\n    float: unset;\r\n    padding-left: 17%;\r\n    font-size: 13px;\r\n  }\r\n}\r\n::ng-deep.mappingCheck label {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.mode_select {\r\n  width: 69%;\r\n  top: -2px;\r\n  background-color: white;\r\n  border: 1px solid #8080804a;\r\n  border-radius: 5px;\r\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  padding-left: 4%;\r\n}\r\n\r\n::ng-deep .mat-form-field-appearance-legacy .mat-form-field-wrapper {\r\n  padding-bottom: 0 !important;\r\n  margin-top: -8px !important;\r\n}\r\n\r\n::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline {\r\n  height: 0px !important;\r\n}\r\n::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {\r\n  top: 0;\r\n  height: 0px !important;\r\n  overflow: hidden;\r\n}\r\n\r\n.port-margin {\r\n  margin-left: 3%;\r\n}\r\n::ng-deep.mode_select .mat-select-trigger {\r\n  min-width: 0 !important;\r\n}\r\n\r\n.fonts_size {\r\n  font-size: $fontsize;\r\n}\r\n\r\n.tfp_copy_icon {\r\n  float: right;\r\n  font-size: 18px !important;\r\n  position: absolute;\r\n  right: 1%;\r\n  cursor: pointer;\r\n  top: 20%;\r\n}\r\n.tfp_mail_icon{\r\n  font-size: 19px !important;\r\n  position: absolute;\r\n  right: 7%;\r\n  cursor: pointer;\r\n  top: 20%;\r\n}\r\n.vitalrbidge_card {\r\n  border: 1px solid rgb(0 0 0 / 13%);\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n}\r\n\r\n.headerdark {\r\n  background-color: #defee4;\r\n  color: black;\r\n  padding-block: 4px;\r\n  position: relative;\r\n  border-top-left-radius: 5px;\r\n  border-top-right-radius: 5px;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n}\r\n\r\n.multiprocessor_div {\r\n  //  max-height: 120px;\r\n  background-color: whitesmoke;\r\n  // overflow-x: hidden;\r\n  // overflow-y: auto;\r\n  // padding-block: 3px;\r\n}\r\n\r\n::ng-deep.multiselect {\r\n  .multiselect-dropdown {\r\n    .dropdown-list {\r\n      max-height: 190px;\r\n      overflow-x: hidden;\r\n      overflow-y: auto;\r\n\r\n      position: absolute;\r\n      padding-top: -12px;\r\n      width: 100%;\r\n      z-index: 9999;\r\n      border: 1px solid #ccc;\r\n      border-radius: 3px;\r\n      background: #fff;\r\n      /* margin-top: 10px; */\r\n      box-shadow: 0 1px 5px #959595;\r\n    }\r\n  }\r\n}\r\n.active_table {\r\n  background-color: #17a2b83b;\r\n}\r\n.configtable td {\r\n  padding: 1% !important;\r\n}\r\n.configtable tr:hover {\r\n  background-color: #f3eded;\r\n  cursor: pointer;\r\n}\r\n.configicon {\r\n  position: relative;\r\n  left: 65%;\r\n}\r\n.copy_icon {\r\n  background-repeat: no-repeat;\r\n  display: inline-block;\r\n  fill: currentColor;\r\n  height: 24px;\r\n  width: 24px;\r\n  font-size: 18px;\r\n  position: relative;\r\n  left: 3px;\r\n  cursor: pointer;\r\n  text-align: center;\r\n  z-index: 999;\r\n}\r\n.message_type {\r\n  width: 100%;\r\n  margin-left: 1%;\r\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  top: -1px;\r\n  height: 31px;\r\n  line-height: 19px;\r\n  padding-left: 4%;\r\n}\r\n::ng-deep .message_type .mat-form-field-appearance-legacy .mat-form-field-wrapper {\r\n  padding-bottom: 0 !important;\r\n  margin-top: -4px !important;\r\n}\r\n::ng-deep .mat-form-field-appearance-legacy .mat-form-field-wrapper {\r\n  padding-bottom: 0 !important;\r\n  margin-top: -8px !important;\r\n}\r\n.text-ellipsis{\r\n  max-width: 83%;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n::ng-deep .pipeline_feild .autocomplete-container.input-container input:disabled {\r\n  background-color: #eee !important;\r\n}\r\n::ng-deep .pipeline_feild.pipleline_input .autocomplete-container .input-container input {\r\n  box-shadow: 0 1px 1px #959595 !important;\r\n  height: 30px !important;\r\n  border: transparent !important\r\n}\r\n.configbtn_style {\r\n  border: none;\r\n  border-top: 34px solid #fafafa !important;\r\n  border-right: 34px solid #17a0b4 !important;\r\n  border-bottom: 34px solid #fafafa !important;\r\n  border-left-color: #17a0b4 !important;\r\n}\r\n.filecompare_input{\r\n  height:$inputHeight;\r\n  font-size: 11px;\r\n  padding-left: 1%;\r\n\r\n}\r\n.filecompare_input,\r\ninput::-webkit-input-placeholder {\r\n  font-size: 11px !important;\r\n}\r\n.vpninputstyle{\r\n  height:30px !important;\r\n  font-size: 11px;\r\n  padding-left: 1%;\r\n  border-radius: 5px;\r\nwidth: 100%;\r\n}\r\n.vpninputstyle,\r\ninput::-webkit-input-placeholder {\r\n  font-size: 11px !important;\r\n}\r\n.addconfigbtn{\r\n  background-color:$btn-color;\r\n  font-size: $fontsize;\r\n  color:white ;\r\n  height: $btnHeight;\r\n  line-height: 20px;\r\n  right: 1%;\r\n  top: 0%;\r\n  cursor: pointer;\r\n}\r\n.dot {\r\n  height: 22px;\r\n  width: 25px;\r\n  background-color: #17a0b4 !important;\r\n  border-radius: 50%;\r\n  display: inline-block;\r\n}\r\n.agentsearch_field{\r\n  height: $btnHeight;\r\n  padding: 0%;\r\n  padding-left: 2%;\r\n  font-size:$fontsize;\r\n}\r\n.agentsearch_field::placeholder{\r\n  font-size: $fontsize;\r\n}\r\n.agentfilter_feild{\r\n  width:94%!important\r\n}\r\n.additioninfo_active{\r\n  color: green!important;\r\n}\r\n.additioninfo_inactive{\r\n  color: red!important;\r\n}\r\n.description{\r\n  font-size: $fontsize;\r\n}\r\n\r\n::ng-deep.interfacedescriptioncreate .modal-dialog {\r\n  max-width: 40%!important;\r\n  max-height: 40%!important;\r\n  height: 30%!important;\r\n  margin: auto!important;\r\n  padding: 0 !important;\r\n  top:10%!important;\r\n}\r\n::ng-deep.interfacedescriptioncreate{\r\n  top: 10%!important;\r\n}\r\n\r\n::ng-deep.additionalsettingmodal .modal-dialog {\r\n  max-width: 40%!important;\r\n  max-height: 40%!important;\r\n  height: 30%!important;\r\n  margin: auto!important;\r\n  padding: 0 !important;\r\n  top:16%!important;\r\n}\r\n::ng-deep.additionalsettingmodal{\r\n  top: 16%!important;\r\n}\r\n\r\n::ng-deep.saveVendormodalcreate .modal-dialog {\r\n  max-width: 58%!important;\r\n  max-height: 60%!important;\r\n  height: 60%!important;\r\n  margin: auto!important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.saveVendormodalcreate{\r\n  top: 16%!important;\r\n}\r\n\r\n::ng-deep.modalConfigcreate .modal-dialog {\r\n  max-width: 36% !important;\r\n  max-height: 60% !important;\r\n  height: 60% !important;\r\n  margin: auto !important;\r\n  padding: 0 !important;\r\n  top: 24%!important;\r\n}\r\n\r\n::ng-deep.modalConfigJSONcreate .modal-dialog {\r\n  max-width:79% !important;\r\n  margin: auto !important;\r\n  padding: 0 !important;\r\n  top: 0%!important;\r\n}\r\n\r\n.recreate_btn{\r\n  border: none;\r\n  border-radius: 17px;\r\n  box-shadow: 1px 1px 4px 1px grey;\r\n  cursor: pointer;\r\n}\r\n\r\n.copyicon\r\n{\r\n  position: absolute;\r\n    right: 13%;\r\n    top: 22%;\r\n    font-size: 18px;\r\n    cursor: pointer;\r\n}\r\n.folderpathvaftp{\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  margin-top:16px;\r\n  right: 3%;\r\n}\r\n.folderpathftp{\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  right: 3%;\r\n}\r\n.copyicon_pn\r\n{\r\nright: 14%;\r\n}\r\n.copyicon_proc\r\n{\r\n  right: 17%;\r\n}\r\n.copyicon_procsub{\r\n  right: 15%;\r\n  top: 26%;\r\n  position: absolute;\r\n  font-size: 18px;\r\n}\r\n.copyicon_procsubedit\r\n{\r\n  right: 8%;\r\n  top: 13%;\r\n  position: absolute;\r\n  font-size: 18px;\r\n}\r\n.mappingbtnprocsubedit{\r\n  padding-left: 1%;\r\n    position: relative;\r\n    top: 3%;\r\n    left: 6%;\r\n}\r\n.rightbottom\r\n{\r\n  position: absolute;\r\n    bottom: 0;\r\n    width: 100%;\r\n}\r\n.modal {\r\n  &.drawer {\r\n    display: flex !important;\r\n    pointer-events: none;\r\n\r\n    * {\r\n      pointer-events: none;\r\n    }\r\n\r\n    .modal-dialog {\r\n      margin: 0px;\r\n      flex: auto;\r\n      transform: translate(25%, 0);\r\n\r\n      .modal-content {\r\n        border: none;\r\n        border-radius: 0px;\r\n\r\n        .modal-body {\r\n          overflow: auto;\r\n\r\n        }\r\n      }\r\n    }\r\n\r\n    &.show {\r\n      pointer-events: auto;\r\n\r\n      * {\r\n        pointer-events: auto;\r\n      }\r\n\r\n      .modal-dialog {\r\n        transform: translate(0, 0);\r\n      }\r\n    }\r\n\r\n    &.right-align {\r\n      flex-direction: row-reverse;\r\n    }\r\n\r\n    &.left-align {\r\n      &:not(.show) {\r\n        .modal-dialog {\r\n          transform: translate(-25%, 0);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .modal-title {\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n::ng-deep.duplicate-modal-rightcreate {\r\n  &.drawer.right-align {\r\n    .modal-dialog {\r\n      position: fixed;\r\n      right: 0;\r\n      top: 16%;\r\n      bottom: 0;\r\n      width: 50%;\r\n      max-width: 50%;\r\n      height: 100%;\r\n      margin: 0;\r\n      transform: translateX(100%);\r\n      transition: transform 0.3s ease-in-out;\r\n    }\r\n    \r\n    &.show .modal-dialog {\r\n      transform: translateX(0);\r\n    }\r\n  }\r\n}\r\n\r\n\r\n.folder_path_input{\r\n  font-size: 11px !important;\r\n    box-sizing: border-box !important;\r\n    border: none !important;\r\n    box-shadow: none !important;\r\n    outline: 0 !important;\r\n    background-color: #fff !important;\r\n    color: rgba(0, 0, 0, 0.87) !important;\r\n    width: 100% !important;\r\n    padding: 0 15px !important;\r\n    line-height: 30px !important;\r\n    height: 30px !important;\r\n    border-radius: 5px !important;\r\n    padding-left: 5px !important;\r\n    position: relative;\r\n    padding-right: 10% !important;\r\n    box-shadow: 0px 1px 5px 0px grey !important;\r\n}\r\n\r\n.projectimportradio{\r\n  height: auto !important;\r\n}\r\n\r\n.otherradio{\r\n  max-height: 62vh;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n}\r\n\r\n/* API contract mode: allow autocomplete suggestions outside the card */\r\n.api-connectivity-card {\r\n  max-height: none !important;\r\n  overflow-x: hidden;\r\n  overflow-y: visible !important;\r\n}\r\n\r\n/* Ensure no intermediate wrapper clips the API agent suggestion panel */\r\n.api-connectivity-card .card-body,\r\n.api-connectivity-card .fonts_size,\r\n.api-contract-controls-row,\r\n.api-connectivity-card .ng-autocompleteaccount,\r\n.api-connectivity-card .ng-autocompleteaccount form,\r\n.api-connectivity-card .api-contract-agent-field,\r\n.api-connectivity-card .api-contract-agent-field .autocomplete-container,\r\n.api-connectivity-card .api-contract-agent-field .autocomplete-container .suggestions-container {\r\n  overflow: visible !important;\r\n}\r\n.form-control{\r\n  border-radius: 5px !important;\r\n  font-size: 1rem !important;\r\n  height: 110px !important;\r\n}\r\n::ng-deep.devicesearch .autocomplete-container .suggestions-container.is-visible{\r\nposition: fixed !important;\r\nwidth: 28% !important;\r\nvisibility:  visible;\r\n}\r\n.fieldstyle{\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%);height: 30px !important; border-radius: 5px !important;    border: transparent;\r\n  width:98% !important;\r\n}\r\n.visibility_off{\r\n  color: #17a2b8;\r\n  height: 19px !important;\r\n  width: 33px !important;\r\n  font-size: 19px;\r\n  padding-left: 13px;\r\n  position: relative;\r\n  top: 1px;\r\n  cursor: pointer; \r\n}\r\n.visibilityftp{\r\n  color: #17a2b8;\r\n  height: 19px !important;\r\n  width: 33px !important;\r\n  font-size: 19px;\r\n  cursor: pointer;\r\n}\r\n.additional_seting{\r\n   display: flex; \r\n   justify-content: space-between; \r\n   width: 100%;\r\n   font-size: 12px;\r\n}\r\n.status-live{\r\n  height: 7px;\r\n  width: 7px;\r\n  background-color: #06d306;\r\n  border-radius: 50%;\r\n  position: relative;\r\n  bottom: 3px;\r\n  left: -2px;\r\n  animation: blink 1s infinite;\r\n}\r\n.externalftfp_copy_icon {\r\n  float: right;\r\n  font-size: 18px !important;\r\n  position: absolute;\r\n  right: 1%;\r\n  cursor: pointer;\r\n  top: 3%;\r\n  color: black;\r\n}\r\n@keyframes blink {\r\n  0%, 100% { opacity: 1; }\r\n  50% { opacity: 0.3; }\r\n}\r\n::ng-deep.vendorauto .input-container input:disabled{\r\n  cursor: not-allowed !important;\r\n}\r\n\r\n/* Additional Info card loader */\r\n::ng-deep .additional-info-spinner circle {\r\n  stroke: #17a2b8 !important;\r\n}\r\n\r\n::ng-deep .additional-info-spinner .mdc-circular-progress__indeterminate-circle-graphic {\r\n  stroke: #17a2b8 !important;\r\n}\r\n\r\n/* Saved pipeline: read-only connectivity — neutral panel + accent; left-aligned (not centered) */\r\n.connectivity-readonly-summary {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: stretch;\r\n  margin: 6px 0 12px;\r\n  padding: 0;\r\n  line-height: 1.4;\r\n}\r\n\r\n.connectivity-readonly-chip {\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  min-height: 44px;\r\n  padding: 11px 16px 12px;\r\n  text-align: left;\r\n  background: #f8fafc;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 0 8px 8px 0;\r\n  border-left: 3px solid #0f766e;\r\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);\r\n}\r\n\r\n.connectivity-readonly-value {\r\n  display: block;\r\n  width: 100%;\r\n  min-width: 0;\r\n  color: #0f172a;\r\n  font-size: 14px !important;\r\n  font-weight: 600;\r\n  line-height: 1.4;\r\n  letter-spacing: -0.01em;\r\n  word-break: break-word;\r\n}\r\n/* Compact auth type select shown above API contract builder */\r\n::ng-deep .auth-type-field .mat-mdc-text-field-wrapper {\r\n  padding-bottom: 0 !important;\r\n  margin: 0 !important;\r\n}\r\n\r\n::ng-deep .auth-type-field .mat-mdc-form-field-flex {\r\n  min-height: 34px !important;\r\n  height: 34px !important;\r\n  align-items: center;\r\n}\r\n\r\n::ng-deep .auth-type-field .mat-mdc-form-field-infix {\r\n  border-top: 0 !important;\r\n  padding: 0.35em 0 0.35em 0 !important;\r\n}\r\n::ng-deep .api-contract-agent-field .autocomplete-container .input-container input {\r\n  min-height: 34px !important;\r\n  height: 34px !important;\r\n  line-height: 34px !important;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Fixed width for VA-API agent picker only */\r\n.api-contract-agent-field {\r\n  width: 310px;\r\n  max-width: 310px;\r\n  flex: 0 0 310px;\r\n}\r\n\r\n.api-contract-agent-field .apiagentsearch,\r\n::ng-deep .api-contract-agent-field .autocomplete-container {\r\n  width: 100%;\r\n  max-width: 310px;\r\n}\r\n\r\n/* Keep API agent suggestions above neighboring controls */\r\n::ng-deep .api-contract-agent-field .autocomplete-container .suggestions-container.is-visible {\r\n  z-index: 10050 !important;\r\n}\r\n\r\n/* Escape clipped parent cards (otherradio / card-body scroll areas) */\r\n::ng-deep .apiagentsearch .autocomplete-container .suggestions-container.is-visible {\r\n  position: fixed !important;\r\n  width: 300px !important;\r\n  max-height: 240px;\r\n  overflow-y: auto;\r\n  z-index: 10050 !important;\r\n  visibility: visible;\r\n}\r\n\r\n.api-connectivity-card-body {\r\n  max-height: none !important;\r\n  overflow-y: visible !important;\r\n}\r\n\r\n.agent-info-namediv {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.agent-info-namediv:hover {\r\n  background-color: #3fa4fb;\r\n  border-radius: 12px;\r\n  color: white !important;\r\n  padding: 3px !important;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n}\r\n\r\n.copy_iconss {\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n}","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
